<h2 mat-dialog-title translate>Create New Activity Page</h2>
<mat-dialog-content>
  <div class="form-group">
    <div *ngFor="let question of questions; trackBy: trackByQuestionKey">
      <app-question [question]="question" [form]="pageForm"></app-question>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" class="cancel_button" translate>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    class="submit-button"
    aria-label="Submit the form"
    (click)="onSubmit()"
  >
    {{ isEditMode ? "Update" : "Submit" }}
  </button>
</mat-dialog-actions>
